import { Any, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class FavoritePage {
  constructor (
    name?: string,
    params?: any
  ) {
    this.name = name as any;
    this.params = params as any;
  }

  @JsonProperty(String)
  name: string;

  @JsonProperty(Any)
  @Optional
  params: any;
}
